import {
  ADD_QUIZZ_ANSWER,
  ADD_QUIZZ_ANSWER_SUCCESS,
  ADD_QUIZZ_ANSWER_CLEAN,
  ADD_QUIZZ_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  answer: undefined,
}

const QuizzAnswerAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUIZZ_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_QUIZZ_ANSWER_SUCCESS:
      state = {
        ...state,
        answer: action.payload.answer,
        loading: false,
        done: true,
      }
      break
    case ADD_QUIZZ_ANSWER_CLEAN:
      state = initialState
      break
    case ADD_QUIZZ_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuizzAnswerAdd
